import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import {
    FloatingActionButton,
    FloatingActionButtons,
} from "../../../components/floatingActionButton";
import * as LayoutActions from "../../layout/actions";
import { OrdersReportTable } from "../components/OrdersReportTable";
import { ReportActiveFilters } from "../components/ReportActiveFilters";
import { useOrdersReportData } from "../hooks/useOrdersReportData";
import { useOrdersReportExcel } from "../hooks/useOrdersReportExcel";
import { useOrdersReportPdf } from "../hooks/useOrdersReportPdf";
import { useReportDates } from "../hooks/useReportDates";
import { useReportFilters } from "../hooks/useReportFilters";
import { useReportOrders } from "../hooks/useReportOrders";
import { OrdersReportLayout } from "./OrdersReportLayout";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const m = defineMessages({
    title: { id: "OrdersReportPage.title", defaultMessage: "Orders by client report" },
});

export const OrdersReportPage = () => {
    const { formatMessage } = useIntl();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(LayoutActions.setPageTitle(formatMessage(m.title)));
    }, [dispatch, formatMessage]);

    const { filters, clearFilter } = useReportFilters();

    const { reportMonthsInOrder, currentPeriodEndDate, previousPeriodStartDate } = useReportDates();

    const { ordersStat, isLoading: isLoadingOrders } = useReportOrders(
        previousPeriodStartDate,
        currentPeriodEndDate,
        filters,
    );

    const { ordersReportData, isProcessing } = useOrdersReportData(
        ordersStat,
        filters,
        reportMonthsInOrder,
        previousPeriodStartDate,
        currentPeriodEndDate,
    );

    const isLoading = isLoadingOrders || isProcessing;

    const { getDocumentDefinition } = useOrdersReportPdf(ordersReportData);

    const generatePdf = () => {
        const documentDefinition = getDocumentDefinition();
        pdfMake.createPdf(documentDefinition).download(`${formatMessage(m.title)}.pdf`);
    };

    const { exportToExcelAndDownload } = useOrdersReportExcel();

    const exportToExcel = () => exportToExcelAndDownload(ordersReportData);

    return (
        <OrdersReportLayout>
            <ReportActiveFilters onClear={clearFilter} />
            <OrdersReportTable ordersReportData={ordersReportData} isLoading={isLoading} />
            <FloatingActionButtons>
                <FloatingActionButton icon="file excel outline" onClick={exportToExcel} />
                <FloatingActionButton icon="file pdf" onClick={generatePdf} />
                <FloatingActionButton
                    icon="filter"
                    onClick={() => navigate(`/reports/orders/filters${location.search}`)}
                />
            </FloatingActionButtons>
        </OrdersReportLayout>
    );
};
